import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { WifiOff, X } from 'lucide-react';

export function WebSocketErrorBanner() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handler = () => setVisible(true);
    window.addEventListener('traccar:wsError', handler);
    return () => window.removeEventListener('traccar:wsError', handler);
  }, []);

  if (!visible) return null;

  return (
    <div className="flex items-center gap-3 bg-destructive/10 border-b border-destructive/20 px-4 py-2 text-sm text-destructive">
      <WifiOff className="h-4 w-4 shrink-0" />
      <span className="flex-1">{t('common.wsError', { defaultValue: 'Real-time updates unavailable — WebSocket connection failed. Live data and command results will not update automatically.' })}</span>
      <button onClick={() => setVisible(false)} className="shrink-0 hover:opacity-70">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
